module.exports = __webpack_public_path__ + "img/20230912-084352.fd7db0e0.webp";